module.exports = __webpack_public_path__ + "static/img/surface5.c0a9be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface5.png
// module id = tjAM
// module chunks = 2